import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../helpers/react.js";
import { Font } from "../Font/index.js";
import { IconWrapper } from "../IconWrapper/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index32.css';const tray = "_tray_1hvgh_1";
const item = "_item_1hvgh_6";
const videoTray = "_videoTray_1hvgh_14";
const itemVideo = "_itemVideo_1hvgh_18";
const activeState = "_activeState_1hvgh_38";
const indexType = "_indexType_1hvgh_47";
const trayModal = "_trayModal_1hvgh_85";
const s = {
  tray,
  item,
  videoTray,
  itemVideo,
  activeState,
  indexType,
  trayModal
};
const CLASS_NAME_MAP = {
  "tray-video": s.videoTray,
  "index-type": s.indexType,
  "tray-modal": s.trayModal
};
const Item = forwardRef(({ children, className, active, icon, ...rest }, ref) => {
  return /* @__PURE__ */ jsx(Font, { type: "text", size: 14, weight: "medium", children: /* @__PURE__ */ jsxs(
    "button",
    {
      disabled: active,
      ...rest,
      className: clsx(
        s.item,
        s.itemVideo,
        {
          [s.activeState]: active
        },
        className
      ),
      ref,
      children: [
        children,
        /* @__PURE__ */ jsx(IconWrapper, { children: icon })
      ]
    }
  ) });
});
const Tray = withThemeAndSize(
  forwardRef(({ children, className, segmentedControlType, ...rest }, ref) => /* @__PURE__ */ jsx("div", { ...rest, className: clsx(s.tray, CLASS_NAME_MAP[segmentedControlType], className), ref, children }))
);
const SegmentedControl = {
  Tray,
  Item
};
export {
  SegmentedControl
};
